import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { Box, Button, CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { memo, useContext, useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../../../../App";
import Scale from "assets/images/scale.png";
import {
  dataRetriveWhenPageRefresh,
  deleteItemThroughScanner,
  editCart,
  flushCart,
  getProductDetails,
  getBundleIMS,
} from "../../../../../../config/Services";
import { eventTrackerConstant } from "../../../../../common/event-tracker/event-tracker-constants";
import { eventTracker } from "../../../../../common/event-tracker/eventTracker";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { normalizeNumber } from "../../Middleware/commonUtils";
import { addcoupon } from "../../redux/Actions/couponActions";
import { resetStateWithoutTime, setManuallyRemovedItems } from "../../redux/Actions/eventTracker";
import { setFocus } from "../../redux/Actions/paginationActions";
import { getFullState, getManuallyRemovedItems } from "../../redux/Reducers/eventTrackerReducer";
import "./CartItemTable.css";
import Swal from "sweetalert2";
import { getFromLocalStorage } from "../../../../../../utils/localStorageHelpers";
import CartItemDrawer from "./Drawer/CartItemDrawer/CartItemDrawer";
import weightIcon from "../../../../../../assets/images/weight-type.png";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { GiftIcon, TrashIcon } from "@heroicons/react/24/outline";
import BundleDetail from "../twoWaykeyboardPaymentPage/components/BundleDetail";

const newSwal = Swal.mixin({
  customClass: {
    confirmButton: "button button-success",
    cancelButton: "button button-error",
    container: "my-swal-container",
  },
  buttonsStyling: false,
});

const COUNT_UNITS = ["each", "nos", "no", "pc", "pcs", "piece", "pieces"];

const isCountUnit = (unit) => COUNT_UNITS?.includes(unit?.toString().trim().toLowerCase());

const CartItemTable = ({
  e, // cartItems - individual items = e
  i, // index of the individual cart items
  currentIndexBox,
  setcurrentIndexBox,
  changeStyle,
  setCurrentRow,
  // start,
}) => {
  const showSnackbar = useSnackbar();
  const { animationBox, setanimationBox } = useContext(UserContext);
  const {
    gtinItem,
    setItemgtin,
    cartItems,
    couponApplied,
    setCouponApplied,
    highlightedCartProductId,
  } = useContext(UserContext);
  const { highlightMrp, setHighlightMrp } = useContext(UserContext);
  const { setTotal, setSubTotal, setCgst, setSgst, setCartId, total, setOfferFound, setCess } =
    useContext(UserContext);
  const { setCartItems, setCartTotalQty } = useContext(UserContext);
  const [cartQuantity, setCartquantity] = useState("");
  const locId = localStorage.getItem("locId");
  const cartId = localStorage.getItem("CartId");
  const branchSubType = localStorage.getItem("branchSubType");
  var myDiv = document.getElementById("move-to-top-wrapper");
  const dispatch = useDispatch();
  const [appliedState, setAppliedState] = useState(false);
  const [quantity, setQuantity] = useState("");
  const manuallyRemovedtItems = useSelector(getManuallyRemovedItems);
  const orderMetricDataFullState = useSelector(getFullState);
  const [spValue, setSpValue] = useState("");
  const canEditSP = !!getFromLocalStorage("appConfig")?.enabledFeatures?.SELL_PRICE_EDIT;
  // const expiryIndicator =
  //   !!getFromLocalStorage("appConfig")?.enabledFeatures?.EXPIRED_ITEM_INDICATOR;
  const expiryIndicator = false;

  const [cartItemModalOpen, setCartItemModalOpen] = useState(false);
  const [bundleDetailModalOpen, setBundleDetailModalOpen] = useState(false);
  const [bundleDetailData, setBundleDetailData] = useState(null);
  const [bundleDetailLoading, setBundleDetailLoading] = useState(false);

  // ── NEW: loading state for +/- stepper buttons ──────────────────────────────
  const [qtyLoading, setQtyLoading] = useState(false);
  // ────────────────────────────────────────────────────────────────────────────

  const [updateResponseCartTime, setUpdateResponseCartTime] = useState(() => {
    const item = localStorage.getItem("updateCartResponseTime");
    try {
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.error("Error parsing updateCartResponseTime from localStorage", error);
      return [];
    }
  });

  let retailUserDetails = null;
  const storedDetails = localStorage.getItem("retailUserDetails");
  if (storedDetails) {
    try {
      retailUserDetails = JSON.parse(storedDetails);
    } catch (error) {
      console.error("Failed to parse retailUserDetails:", error);
    }
  }
  const uidx = retailUserDetails?.uidx;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    color: "black",
  };

  // Keep coupon state driven by the API response: if the backend still has a
  // coupon applied on the cart, keep/update it everywhere; otherwise clear it.
  const syncCouponFromCart = (cartData) => {
    const nextCoupon = cartData?.cartCoupon || null;
    if (nextCoupon?.couponValue) {
      dispatch(addcoupon(nextCoupon));
      localStorage.setItem("cartCoupon", JSON.stringify(nextCoupon));
      setCouponApplied(nextCoupon?.couponValue);
    } else {
      const storedCoupon = localStorage.getItem("cartCoupon");
      const wasCouponApplied =
        !!storedCoupon && storedCoupon !== "undefined" && storedCoupon !== "null";
      dispatch(addcoupon(null));
      localStorage.removeItem("cartCoupon");
      setCouponApplied(cartData?.billing?.appliedCoupon || "0");
      if (wasCouponApplied) {
        showSnackbar("Coupon got removed", "info");
      }
    }
  };

  // Changing the cart invalidates any redeemed loyalty, so it is cleared here.
  // Mirrors syncCouponFromCart: only notify when loyalty was actually applied.

  const fetchBundleDetail = async (bundleBarcode, initialData) => {
    setBundleDetailLoading(true);
    try {
      const [pdRes, imsRes] = await Promise.all([
        getProductDetails(bundleBarcode, locId),
        getBundleIMS(bundleBarcode, locId),
      ]);
      const detail = pdRes?.data?.data;
      const imsBody = imsRes?.data?.bundle || imsRes?.data?.data?.bundle || null;

      // Construct variants from IMS bundleProducts since CMS doesn't return variants for bundles
      let variants = [];
      if (imsBody?.bundleProducts?.length) {
        variants = imsBody?.bundleProducts.map((bp, idx) => ({
          variantId: bp?.bundleProductId || `bundle-product-${idx}`,
          name: bp?.itemName || bp?.gtin,
          barcodes: [bp?.gtin],
          gtin: bp?.gtin,
          mrpData: [{ mrp: bp?.mrp }],
          sellingPrice: bp?.sellingPrice,
          purchasePrice: bp?.purchasePrice,
          weightUnit: "Nos",
          sellingUnit: "Nos",
          inventorySync: {
            gtin: bp?.gtin,
            mrp: bp?.mrp,
            sellingPrice: bp?.sellingPrice,
            purchasePrice: bp?.purchasePrice,
            batchNo: bp?.inventoryIds?.[0],
            bundleQuantity: bp?.quantity,
          },
        }));
      }

      // Start with initial cart data
      const enrichedData = { ...initialData };

      // Add CMS detail fields (description, etc.)
      if (detail) {
        Object.assign(enrichedData, detail);
      }

      // Add constructed variants and IMS bundle
      if (variants?.length) enrichedData.variants = variants;
      if (imsBody?.bundleProducts?.length) enrichedData.imsBundle = imsBody;

      // Map fields exactly as BundleList provides them to BundleDetail
      // BundleList passes: bundlePrice, externalSalesChannels[0].salePrice, bundleBarcode, bundleEndDate, title, name, description, shortDescription
      // IMPORTANT: Use ONLY IMS dates for bundleStartDate/bundleEndDate (not cart expiryDate) to match BundleList behavior
      enrichedData.bundlePrice = imsBody?.mrp ?? initialData?.mrp ?? 0;
      enrichedData.externalSalesChannels = [
        {
          salePrice: imsBody?.sellingPrice ?? initialData?.sellingPrice ?? 0,
        },
      ];
      enrichedData.bundleBarcode =
        imsBody?.bundleGtin ?? initialData?.gtin ?? initialData?.bundleBarcode;
      enrichedData.bundleQuantity = imsBody?.totalQuantity ?? initialData?.quantity ?? 1;
      enrichedData.bundleStartDate = imsBody?.startDate ?? null;
      enrichedData.bundleEndDate = imsBody?.endDate ?? null; // Don't use cart expiryDate - different meaning
      enrichedData.title =
        imsBody?.title ?? initialData?.productName ?? initialData?.variantName ?? "Untitled bundle";
      enrichedData.name =
        imsBody?.title ?? initialData?.productName ?? initialData?.variantName ?? "Untitled bundle";
      enrichedData.description = detail?.description ?? detail?.derived_description ?? "";
      enrichedData.shortDescription = detail?.description ?? detail?.derived_description ?? "";

      setBundleDetailData(enrichedData);
    } catch (err) {
      showSnackbar("Failed to fetch bundle details:", "warning");
      setBundleDetailData(initialData);
    } finally {
      setBundleDetailLoading(false);
    }
  };
  const clearLoyaltyFromCart = () => {
    const storedLoyalty = localStorage.getItem("loyaltyPoints");
    const wasLoyaltyApplied =
      !!storedLoyalty &&
      storedLoyalty !== "undefined" &&
      storedLoyalty !== "null" &&
      storedLoyalty !== "0";
    localStorage.removeItem("loyaltyPoints");
    if (wasLoyaltyApplied) {
      showSnackbar("Loyalty removed", "info");
    }
  };

  const formatQty = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return String(num);
  };

  const isWeighingBarcode = useMemo(() => !!e?.quantityBySpecs, [e]);
  const isProfilerOn = localStorage.getItem("profilerSwitch") === "true";

  useMemo(() => {
    if (e?.sellingUnit === "nos" || e?.sellingUnit === "no") setCartquantity(e?.quantity);
    else setCartquantity(e?.quantityBySpecs !== null ? formatQty(e?.quantityBySpecs) : e?.quantity);
    setSpValue(e?.sellingPrice);
  }, [e]);

  const handleSubmitEdit = async (item, overrideQty) => {
    const qtyToUse = overrideQty !== undefined ? String(overrideQty) : cartQuantity;
    dispatch(setFocus(false));
    setHighlightMrp(item?.sellingPrice);
    const payload = {
      cartId: cartId,
      cartProductId: item?.cartProductId,
      sellingPrice: item?.sellingPrice,
      gtin: item?.gtin,
      qty: isWeighingBarcode ? 1 : qtyToUse,
      locationId: locId,
      mrp: item?.mrp,
      batchNo: item?.batchNo,
      purchasePrice: "",
      inventoryChecks: "NO",
      quantityBySpecs: isWeighingBarcode ? qtyToUse : null,
      sellingUnit: item?.sellingUnit,
    };
    const editPayload = {
      cartId: cartId,
      cartProductId: item?.cartProductId,
      qty: isWeighingBarcode ? 1 : qtyToUse,
      quantityBySpecs: isWeighingBarcode ? qtyToUse : null,
      updatedBy: uidx,
      sellingPrice: payload?.sellingPrice,
    };
    const itemFound = cartItems?.find((cartItem) => cartItem?.gtin === item?.gtin);
    if (Number(qtyToUse) < itemFound?.quantity && qtyToUse !== "0") {
      const metaData = {
        itemId: payload?.gtin,
        quantity: itemFound?.quantity - Number(qtyToUse),
        sellingPrice: payload?.sellingPrice,
        mrp: payload?.mrp,
        cartId: payload?.cartId,
      };
      eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
    }

    if (qtyToUse === "0") {
      const payloadDelete = {
        cartId: cartId,
        sellingPrice: item?.sellingPrice,
        gtin: item?.gtin,
        qty: isWeighingBarcode ? 1 : qtyToUse,
        locationId: locId,
        mrp: item?.mrp,
        batchNo: item?.batchNo,
        purchasePrice: "",
        inventoryChecks: "NO",
        quantityBySpecs: isWeighingBarcode ? qtyToUse : null,
        sellingUnit: item?.sellingUnit,
      };
      await deleteItemThroughScanner(payloadDelete)
        .then((res) => {
          if (res?.data?.status === "SUCCESS") {
            showSnackbar("Cart item removed successfully", "success");
            const metaData = {
              itemId: payload?.gtin,
              quantity: itemFound?.quantity - Number(qtyToUse),
              sellingPrice: payload?.sellingPrice,
              cartId: payload?.cartId,
              mrp: payload?.mrp,
            };
            eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
            dispatch(setManuallyRemovedItems(manuallyRemovedtItems + 1));
            const backupData = {
              ...orderMetricDataFullState,
              manuallyRemovedItems: manuallyRemovedtItems + 1,
            };
            localStorage.setItem("orderMetricData", JSON.stringify(backupData));
            setCartItems(
              res?.data?.data?.cartProducts.sort((a, b) =>
                b?.modifiedDate.localeCompare(a?.modifiedDate)
              )
            );
            setOfferFound(res?.data?.data?.offerProductFound);
            setCartTotalQty(res?.data?.data?.billing?.quantity);
            setCgst(res?.data?.data?.billing?.cgst);
            setSgst(res?.data?.data?.billing?.sgst);
            setCess(res.data.data.billing.totalCessAmount);
            setTotal(res?.data?.data?.billing?.totalCartValue);
            setSubTotal(res?.data?.data?.billing?.subtotal);
            syncCouponFromCart(res?.data?.data);
            clearLoyaltyFromCart();
            setAppliedState(!appliedState);
            setItemgtin("");
            setHighlightMrp("");
            setQuantity(res?.data?.data?.billing?.quantity);
            document.activeElement.blur();
          }
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
        });
    } else {
      const start = new Date().getTime();
      await editCart(editPayload)
        .then((res) => {
          if (!!res?.data?.data.es) {
            showSnackbar(res?.data?.data?.message, "error");
            return;
          }
          if (isProfilerOn) {
            const end = new Date().getTime();
            const timeTaken = end - start;
            const updatedCartUpdateResponseTimes = [
              ...updateResponseCartTime,
              { time: end, responseTime: timeTaken },
            ];
            localStorage.setItem(
              "updateCartResponseTime",
              JSON.stringify(updatedCartUpdateResponseTimes)
            );
            setUpdateResponseCartTime(updatedCartUpdateResponseTimes);
          }

          setCartItems(
            res?.data?.data?.data?.cartProducts.sort((a, b) =>
              b?.modifiedDate.localeCompare(a?.modifiedDate)
            )
          );
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setSubTotal(res?.data?.data?.data?.billing?.subtotal);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing.totalCessAmount);
          syncCouponFromCart(res?.data?.data?.data);
          dispatch(setFocus(false));
          document.activeElement.blur();
          setAppliedState(!appliedState);
          setanimationBox(true);
          setItemgtin(item?.gtin);
          setHighlightMrp(item?.sellingPrice);
          myDiv.scrollTop = 0;
          setcurrentIndexBox(false);
          setQuantity(res?.data?.data?.data?.billing?.quantity);
          clearLoyaltyFromCart();
          // document.getElementById("hiddenBtn").focus();
        })
        .catch((err) => {});
    }
  };

  // ── UPDATED: increment now awaits the API and manages loading state ──────────
  const handleIncrement = async (item) => {
    if (qtyLoading) return;
    const currentQty = parseFloat(cartQuantity) || 0;
    const step = isWeighingBarcode ? (isCountUnit(item?.sellingUnit) ? 1 : 0.01) : 1;
    const newQty = String(parseFloat((currentQty + step).toFixed(2)));
    setQtyLoading(true);
    await handleSubmitEdit(item, newQty);
    setQtyLoading(false);
  };

  // ── UPDATED: decrement now awaits the API and manages loading state ──────────
  const handleDecrement = async (item) => {
    if (qtyLoading) return;
    const currentQty = parseFloat(cartQuantity) || 0;
    const step = isWeighingBarcode ? (isCountUnit(item?.sellingUnit) ? 1 : 0.01) : 1;
    const newQty = parseFloat((currentQty - step).toFixed(2));
    if (newQty < 0) return;
    setQtyLoading(true);
    await handleSubmitEdit(item, String(newQty));
    setQtyLoading(false);
  };

  const handleDelete = async (item) => {
    if (qtyLoading) return;
    setQtyLoading(true);
    await handleSubmitEdit(item, "0");
    setQtyLoading(false);
  };
  // ────────────────────────────────────────────────────────────────────────────

  // ── REMOVED: pendingQtyRef, debounceTimerRef, triggerDebouncedSubmit,
  //             and both cleanup useEffects are no longer needed ───────────────

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteLoader, setdeleteLoader] = useState(false);
  const handleCloseModal = () => {
    setOpenDeleteModal(false);
  };

  //   useEffect(() => {
  //     const handleKeyDown = (event) => {
  //       if (event.key === "F7") {
  //         event.preventDefault();
  //         setOpenDeleteModal(true);
  //       }
  //       if (event.key === "Escape") {
  //         event.preventDefault();
  //         setOpenDeleteModal(false);
  //       }
  //     };
  //     document.addEventListener("keydown", handleKeyDown);
  //     return () => {
  //       document.removeEventListener("keydown", handleKeyDown);
  //     };
  //   }, [openDeleteModal]);

  //flush cart in one go---
  const handleFlush = () => {
    setdeleteLoader(true);
    flushCart(cartId)
      .then((res) => {
        const totalItems = cartItems.reduce(
          (totalQuantity, item) => totalQuantity + item.quantity,
          0
        );
        const metaData = {
          cartId: cartId,
          itemsCount: totalItems,
          amount: total,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.CART_DELETED });
        dispatch(resetStateWithoutTime(0));
        const backupData = {
          ...orderMetricDataFullState,
          manuallyAdded: 0,
          scannedProduct: 0,
          isMultipleBatch: false,
          avgProductAddTime: "",
          totalProducts: 0,
          productTimeArray: [],
          editOrderItem: 0,
          manuallyRemovedItems: 0,
          manualItemsGtin: [],
        };
        localStorage.setItem("orderMetricData", JSON.stringify(backupData));
        setOpenDeleteModal(false);
        setCouponApplied("");
        dispatch(addcoupon(null));
        localStorage.removeItem("cartCoupon");
        dataRetriveWhenPageRefresh(cartId).then((res) => {
          setCartId(res?.data?.data?.data?.cartId);
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCartItems(
            res?.data?.data?.data?.cartProducts.sort((a, b) =>
              b?.modifiedDate.localeCompare(a?.modifiedDate)
            )
          );
          setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing?.totalCessAmount);
          setSubTotal(res?.data?.data?.data?.billing?.subtotal);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setdeleteLoader(false);
        });
      })
      .catch((err) => {
        setdeleteLoader(false);
        setOpenDeleteModal(false);
      });
  };

  useMemo(() => {
    if (currentIndexBox) {
      setCartquantity(e?.quantityBySpecs !== null ? formatQty(e?.quantityBySpecs) : e?.quantity);
    }
  }, [currentIndexBox]);

  const handleChange = (e) => {
    let value = e.target.value;

    if (value.length > 5) {
      value = value.slice(0, 5);
    }

    setCartquantity(value);
  };

  const handleSPChange = (e) => {
    let value = e.target.value;
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    setSpValue(value);
  };

  const handleSPEdit = async (item) => {
    const purchasePrice = parseFloat(item?.purchasePrice).toFixed(2);
    const sellingPrice = parseFloat(spValue).toFixed(2);
    const isBelowPurchase = parseFloat(sellingPrice) < parseFloat(purchasePrice);

    const htmlContent = `
    <div style="margin: 1rem 0;">
      <div style="margin-bottom: 1rem;">
        <p>Purchase Price: ₹${purchasePrice}</p>
        <p>Selling Price: ₹${sellingPrice}</p>
      </div>
      ${
        isBelowPurchase
          ? `
        <div style="color: #dc3545; margin-top: 1rem; padding: 0.5rem; background: #f8d7da; border-radius: 4px;">
          Warning: Selling price is lower than purchase price!
        </div>
      `
          : ""
      }
    </div>
  `;

    newSwal.fire({
      title: "Are you sure you want to edit the selling price?",
      icon: "warning",
      html: htmlContent,
      confirmButtonText: "Proceed",
      showCancelButton: true,
      reverseButtons: true,
      preConfirm: async () => {
        try {
          newSwal.showLoading();
          dispatch(setFocus(false));
          setHighlightMrp(item?.sellingPrice);
          const payload = {
            cartId: cartId,
            cartProductId: item?.cartProductId,
            sellingPrice: spValue,
            qty: isWeighingBarcode ? 1 : cartQuantity,
            quantityBySpecs: isWeighingBarcode ? cartQuantity : null,
            updatedBy: uidx,
          };

          const res = await editCart(payload);
          if (!!res?.data?.data.es) {
            showSnackbar(res?.data?.data?.message, "error");
            throw new Error(res?.data?.data?.message);
          }
          const data = res?.data?.data?.data;
          setCartItems(
            data?.cartProducts.sort((a, b) => b?.modifiedDate.localeCompare(a?.modifiedDate))
          );
          setOfferFound(data?.offerProductFound);
          setCartTotalQty(data?.billing?.quantity);
          setTotal(data?.billing?.totalCartValue);
          setSubTotal(data?.billing?.subtotal);
          setCgst(data?.billing?.cgst);
          setSgst(data?.billing?.sgst);
          setCess(data?.billing.totalCessAmount);
          syncCouponFromCart(data);
          dispatch(setFocus(false));
          document.activeElement.blur();
          setAppliedState(!appliedState);
          setanimationBox(true);
          setItemgtin(item?.gtin);
          setHighlightMrp(item?.sellingPrice);
          myDiv.scrollTop = 0;
          setcurrentIndexBox(false);
          setQuantity(data?.billing?.quantity);
          clearLoyaltyFromCart();
          // document.getElementById("hiddenBtn").focus();
        } catch (err) {
          newSwal.showValidationMessage(`
    Request failed: ${err}
    `);
        } finally {
          newSwal.hideLoading();
        }
      },
      willClose: (dismiss) => {
        if (dismiss && dismiss !== "backdrop") {
          setSpValue(item?.sellingPrice);
          document.activeElement.blur();
        }
      },
      backdrop: "rgba(0,0,0,0.6)",
      returnFocus: false,
    });
  };

  const isExpired = (expiryDate) => {
    if (!expiryDate) return false;
    return new Date(expiryDate) < new Date();
  };

  return (
    <>
      {currentIndexBox ? (
        <tbody>
          <tr
            autoFocus="false"
            tabIndex="-1"
            className={`${
              highlightedCartProductId === e?.cartProductId ? "cartItemTableFlash" : ""
            } ${
              i === 0 && branchSubType !== "FINE_DINE" ? "cartItemTableTopHighlight" : ""
            }`.trim()}
          >
            <td className="grocery-table-type">
              {isWeighingBarcode && (
                <div className="grocery-table-weight">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2A71FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-weight h-3.5 w-3.5"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="5" r="3"></circle>
                    <path d="M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"></path>
                  </svg>
                </div>
              )}
              {e?.isBundle && (
                <div className="bundle-icon-wrapper">
                  <div className="bundle-icon-bg" data-testid="icon-bundle-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-boxes bundle-svg"
                      aria-hidden="true"
                    >
                      <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"></path>
                      <path d="m7 16.5-4.74-2.85"></path>
                      <path d="m7 16.5 5-3"></path>
                      <path d="M7 16.5v5.17"></path>
                      <path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"></path>
                      <path d="m17 16.5-5-3"></path>
                      <path d="m17 16.5 4.74-2.85"></path>
                      <path d="M17 16.5v5.17"></path>
                      <path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"></path>
                      <path d="M12 8 7.26 5.15"></path>
                      <path d="m12 8 4.74-2.85"></path>
                      <path d="M12 13.5V8"></path>
                    </svg>
                  </div>
                </div>
              )}
              {e?.isOfferAvailable && !e?.isBundle && !isWeighingBarcode && (
                <div className="offer-icon-wrapper" title="Offer available">
                  <div className="offer-icon-bg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="11"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M12 2c0 0-5 5.5-5 9.5a5 5 0 0 0 10 0C17 7.5 12 2 12 2z" />
                      <path
                        d="M12 12.5c0 0-2 2-2 3.5a2 2 0 0 0 4 0c0-1.5-2-3.5-2-3.5z"
                        fill="rgba(255,255,255,0.5)"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </td>
            <td className="mrp-space-td">{i + 1}</td>
            <td
              className="productName-text"
              onClick={() => {
                if (e?.isBundle) {
                  setBundleDetailData(e);
                  setBundleDetailModalOpen(true);
                  if (e?.bundleBarcode || e?.gtin) {
                    fetchBundleDetail(e?.bundleBarcode || e?.gtin, e);
                  }
                } else {
                  setCartItemModalOpen(true);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <p className="inner-td-content">
                {`${e?.productName} (${e?.variantName})`}
                {expiryIndicator && isExpired(e?.expiryDate) && (
                  <span className="expired-badge">Expired</span>
                )}
                {(e?.isOversold || e?.availableUnits === 0) && (
                  <span
                    className="oversold-badge"
                    title="Added without available inventory — will be tagged in oversold inventory"
                  >
                    Oversold
                  </span>
                )}
              </p>
              <div className="grocery-barcode-container">
                <div className="product-barcode-text">
                  Barcode:{" "}
                  <span className="barcode-value">
                    {e?.barcode ? e?.barcode : e?.gtin ? e?.gtin : "N/A"}
                  </span>
                </div>
                {e?.isOfferAvailable && (
                  <div className="grocery-offer-chip">
                    <PosCustomIcon
                      icon={<GiftIcon />}
                      height={"12px"}
                      width={"12px"}
                      color="#BB4D00"
                    />
                    <p className="product-offer-text">OFFER AVAILABLE</p>
                  </div>
                )}
              </div>
            </td>
            {/* {e.inventoryWithOffer === null ? ( */}
            <td className="less-space-td">
              <div className="qty-stepper-wrapper">
                <button
                  type="button"
                  className="qty-stepper-btn qty-stepper-btn--minus"
                  onMouseDown={(ev) => ev.preventDefault()}
                  onClick={() => handleDecrement(e)}
                  disabled={qtyLoading}
                >
                  −
                </button>
                <div style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
                  <form
                    onSubmit={async (res) => {
                      res?.preventDefault();
                      setQtyLoading(true);
                      await handleSubmitEdit(e);
                      setQtyLoading(false);
                    }}
                  >
                    <input
                      type="number"
                      step={isWeighingBarcode ? "any" : "1"}
                      className="cartRowItem qty-input qty-stepper-input"
                      required
                      style={{
                        minWidth: `calc(${Math.max(1, String(cartQuantity)?.length)}ch + 15px)`,
                        opacity: qtyLoading ? 0 : 1,
                      }}
                      value={cartQuantity}
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        } else if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                          e.stopPropagation();
                        }
                      }}
                      onFocus={() => dispatch(setFocus(true))}
                      onBlur={() => dispatch(setFocus(false))}
                      onChange={(e) => handleChange(e)}
                      disabled={qtyLoading}
                    />
                  </form>
                  {qtyLoading && (
                    <CircularProgress
                      size={10}
                      sx={{
                        position: "absolute",
                        left: "20%",
                        transform: "translateX(-50%)",
                        color: "inherit",
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </div>
                <button
                  type="button"
                  className="qty-stepper-btn qty-stepper-btn--plus"
                  onMouseDown={(ev) => ev.preventDefault()}
                  onClick={() => handleIncrement(e)}
                  disabled={qtyLoading}
                >
                  +
                </button>
              </div>
            </td>
            {/* // ) : (
            //   <td className="mrp-space-td">{cartQuantity}</td>
            // )} */}
            <td className="mrp-space-td fw-bold">₹{e?.mrp}</td>
            <td className="mrp-space-td fw-bold">
              {/* <button className="hide-me-btn" id="hiddenBtn"></button>₹{e?.sellingPrice} */}
              {canEditSP ? (
                <form
                  onSubmit={(res) => {
                    res?.preventDefault();
                    handleSPEdit(e);
                  }}
                >
                  <input
                    type="number"
                    step="0.01"
                    className="cartRowItem sp-input fw-bold"
                    required
                    value={spValue}
                    onChange={(e) => handleSPChange(e)}
                    onKeyDown={(e) => e.stopPropagation()}
                    onFocus={() => dispatch(setFocus(true))}
                    onBlur={() => dispatch(setFocus(false))}
                  />
                </form>
              ) : (
                e?.sellingPrice
              )}
            </td>
            <td className="fw-bold">{e?.hsnCode}</td>
            <td className="fw-bold">
              {e?.igst !== null && e?.igst !== undefined ? `${e?.igst}%` : "--"}
            </td>
            <td className="mrp-space-td">₹{e?.sgstAmount}</td>
            <td className="mrp-space-td">₹{e?.cgstAmount}</td>

            <td className="mrp-space-td total-column-cell">
              <span>₹{e?.subTotal}</span>
              <TrashIcon
                className="trash-delete-icon"
                onClick={(event) => {
                  event.stopPropagation();
                  handleDelete(e);
                }}
              />
            </td>
          </tr>
        </tbody>
      ) : (
        <tbody>
          <tr
            id={
              animationBox &&
              ((typeof gtinItem === "string" && e?.gtin === gtinItem) ||
                (typeof gtinItem !== "string" && e?.gtin === gtinItem?.gtin)) &&
              (highlightMrp == e?.sellingPrice || e?.sellingPrice === 0)
                ? "myFocusDiv"
                : "myDiv3"
            }
            tabIndex="-1"
            className={`${expiryIndicator && isExpired(e?.expiryDate) ? "expired-row" : ""} ${
              highlightedCartProductId === e?.cartProductId ? "cartItemTableFlash" : ""
            } ${
              i === 0 && branchSubType !== "FINE_DINE" ? "cartItemTableTopHighlight" : ""
            }`.trim()}
          >
            <td className="grocery-table-type">
              {isWeighingBarcode && (
                <div className="grocery-table-weight">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2A71FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-weight h-3.5 w-3.5"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="5" r="3"></circle>
                    <path d="M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"></path>
                  </svg>
                </div>
              )}
              {e?.isBundle && (
                <div className="bundle-icon-wrapper">
                  <div className="bundle-icon-bg" data-testid="icon-bundle-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-boxes bundle-svg"
                      aria-hidden="true"
                    >
                      <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"></path>
                      <path d="m7 16.5-4.74-2.85"></path>
                      <path d="m7 16.5 5-3"></path>
                      <path d="M7 16.5v5.17"></path>
                      <path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"></path>
                      <path d="m17 16.5-5-3"></path>
                      <path d="m17 16.5 4.74-2.85"></path>
                      <path d="M17 16.5v5.17"></path>
                      <path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"></path>
                      <path d="M12 8 7.26 5.15"></path>
                      <path d="m12 8 4.74-2.85"></path>
                      <path d="M12 13.5V8"></path>
                    </svg>
                  </div>
                </div>
              )}
              {e?.isOfferAvailable && !e?.isBundle && !isWeighingBarcode && (
                <div className="offer-icon-wrapper" title="Offer available">
                  <div className="offer-icon-bg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 3z" />
                    </svg>
                  </div>
                </div>
              )}
            </td>
            <td className="mrp-space-td">{i + 1}</td>
            <td
              className="productName-text"
              onClick={() => {
                if (e?.isBundle) {
                  setBundleDetailData(e);
                  setBundleDetailModalOpen(true);
                  if (e?.bundleBarcode || e?.gtin) {
                    fetchBundleDetail(e?.bundleBarcode || e?.gtin, e);
                  }
                } else {
                  setCartItemModalOpen(true);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <p className="inner-td-content">
                {`${e?.productName} (${e?.variantName})`}
                {expiryIndicator && isExpired(e?.expiryDate) && (
                  <span className="expired-badge">Expired</span>
                )}
                {(e?.isOversold || e?.availableUnits === 0) && (
                  <span
                    className="oversold-badge"
                    title="Added without available inventory — will be tagged in oversold inventory"
                  >
                    Oversold
                  </span>
                )}
              </p>
              <div className="grocery-barcode-container">
                <div className="product-barcode-text">
                  Barcode:{" "}
                  <span className="barcode-value">
                    {e?.barcode ? e?.barcode : e?.gtin ? e?.gtin : "N/A"}
                  </span>
                </div>
                {e?.isOfferAvailable && (
                  <div className="grocery-offer-chip">
                    <PosCustomIcon
                      icon={<GiftIcon />}
                      height={"12px"}
                      width={"12px"}
                      color="#BB4D00"
                    />
                    <p className="product-offer-text">OFFER AVAILABLE</p>
                  </div>
                )}
              </div>
            </td>
            {/* {e.inventoryWithOffer ? ( */}
            <td className="less-space-td">
              <div className="qty-stepper-wrapper">
                <button
                  type="button"
                  className="qty-stepper-btn qty-stepper-btn--minus"
                  onMouseDown={(ev) => ev.preventDefault()}
                  onClick={() => handleDecrement(e)}
                  disabled={qtyLoading}
                  tabIndex={-1}
                >
                  −
                </button>

                {/* Wrapper to position spinner over input */}
                <div style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
                  <form
                    className="display-form-wrapper"
                    onSubmit={(res) => {
                      res?.preventDefault();
                      handleSubmitEdit(e);
                    }}
                  >
                    <input
                      type="number"
                      step={isWeighingBarcode ? "any" : "1"}
                      id="cartItemFocus"
                      className="cartRowItem qty-input qty-stepper-input"
                      required
                      style={{
                        minWidth: `calc(${Math.max(1, String(cartQuantity).length)}ch + 15px)`,
                        opacity: qtyLoading ? 0 : 1, // hide text while loading
                      }}
                      value={cartQuantity}
                      onChange={(e) => handleChange(e)}
                      onFocus={() => dispatch(setFocus(true))}
                      onBlur={() => dispatch(setFocus(false))}
                      disabled={qtyLoading}
                    />
                  </form>

                  {/* Spinner sits centered over the input */}
                  {qtyLoading && (
                    <CircularProgress
                      size={10}
                      sx={{
                        position: "absolute",
                        left: "20%",
                        transform: "translateX(-50%)",
                        color: "inherit",
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </div>

                <button
                  type="button"
                  className="qty-stepper-btn qty-stepper-btn--plus"
                  onMouseDown={(ev) => ev.preventDefault()}
                  onClick={() => handleIncrement(e)}
                  disabled={qtyLoading}
                  tabIndex={-1}
                >
                  +
                </button>
              </div>
            </td>
            {/* ) : (
              <td className="mrp-space-td">{cartQuantity}</td>
            )} */}
            <td className="mrp-space-td fw-bold">₹{normalizeNumber(e?.mrp)}</td>
            <td className="mrp-space-td fw-bold">
              {" "}
              {/* <button className="hide-me-btn" id="hiddenBtn"></button>₹
              {normalizeNumber(e?.sellingPrice)}{" "} */}
              {canEditSP ? (
                <form
                  onSubmit={(res) => {
                    res?.preventDefault();
                    handleSPEdit(e);
                  }}
                >
                  <input
                    type="number"
                    step="0.01"
                    className="cartRowItem sp-input fw-bold"
                    required
                    value={spValue}
                    onChange={(e) => handleSPChange(e)}
                    onFocus={() => dispatch(setFocus(true))}
                    onBlur={() => dispatch(setFocus(false))}
                  />
                </form>
              ) : (
                normalizeNumber(e?.sellingPrice)
              )}
            </td>
            <td className="fw-bold">{e?.hsnCode || "--"}</td>
            <td className="fw-bold">
              {e?.igst !== null && e?.igst !== undefined ? `${e?.igst}%` : ""}
            </td>
            <td className="mrp-space-td">₹{normalizeNumber(e?.sgstAmount)}</td>
            <td className="mrp-space-td">₹{normalizeNumber(e?.cgstAmount)}</td>

            <td className="mrp-space-td total-column-cell">
              <span>₹{normalizeNumber(e?.subTotal)}</span>
              <TrashIcon
                className="trash-delete-icon"
                onClick={(event) => {
                  event.stopPropagation();
                  handleDelete(e);
                }}
              />
            </td>
          </tr>
        </tbody>
      )}

      <Modal
        open={openDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={handleCloseModal}
      >
        <Box sx={style}>
          <Typography id="modal-modal-title delete-text-theme" variant="h6" component="h2">
            Are you sure you want to delete all cart Items
          </Typography>

          <Box className="save-wrapper-box">
            <Button className="save-wrapper-btn" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button className="save-wrapper-btn" onClick={() => handleFlush()}>
              {deleteLoader ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Delete"}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* this is the cart item modal */}

      {cartItemModalOpen && (
        <CartItemDrawer
          cartItemModalOpen={cartItemModalOpen}
          setCartItemModalOpen={setCartItemModalOpen}
          cartItemData={e}
        />
      )}

      {/* bundle detail modal */}
      {bundleDetailModalOpen && (
        <Modal
          open={bundleDetailModalOpen}
          onClose={() => setBundleDetailModalOpen(false)}
          slotProps={{ backdrop: { style: { backgroundColor: "rgba(0,0,0,0.4)" } } }}
        >
          <div className="cid__panel">
            {bundleDetailLoading ? (
              <div className="cid__loading-body">
                <div className="cid__spinner" />
                <span className="cid__loading-text">Fetching bundle details…</span>
              </div>
            ) : (
              <BundleDetail
                bundle={bundleDetailData}
                onBack={() => setBundleDetailModalOpen(false)}
              />
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default memo(CartItemTable);
